<template>
  <div>
    <v-autocomplete
      ref="autocomplete"
      @input="event => { this.$emit('input', event) }"
      :label="label ? label : $t('message.search_academies')"
      :loading="loading"
      outlined
      dense
      no-filter
      :items="items"
      item-text="name"
      item-value="_id"
      :search-input.sync="search"
      v-model="selectedValue"
      hide-details
      hide-no-data
    >
    </v-autocomplete>
    <p v-if="!hideMessage" 
      class="text-small text-left">
      {{$t('message.dont_see_academy')}} 
      <a @click="navigateTo({ name: 'addacademy', query: { from: from ? from : '' } })">
        {{$t('message.here')}}
      </a>
    </p>
  </div>
</template>
<script>
import AcademyService from "@/services/AcademyService";

export default {
  data() {
    return {
      loading: false,
      items: /** @type {{_id:string,name:string}[]} */ ([]),
      search: null,
      selectedValue: null,
      academies: /** @type {{_id:string,name:string}[]} */ ([]),
      searchTimer: 0
    };
  },
  components: {
  },
  props: {
    value: null,
    from: null,
    hideMessage: null,
    label: null
  },
  created() {},
  mounted() {},
  watch: {
    value: {
      immediate: true,
      handler: function(newValue) {
        this.selectedValue = newValue;
      }
    },
    search(val) {
      clearTimeout(this.searchTimer);
      if (!val) return;
      this.searchTimer = setTimeout(() => this.querySelections(val), 350);
    }
  },
  methods: {
    async querySelections(v /** @type {string} */) {
      this.loading = true;
      const data = await AcademyService.academiesSimplified(v);
      if (data) this.items = data.academies;
      this.loading = false;
      this.$nextTick(() => {
        const ref = /** @type {any} */ (this.$refs.autocomplete);
        if (ref) ref.focus();
      });
    }
  }
};
</script>

<style scoped>
</style>
